import { CallFavoritesReorderItem } from '../../app/actions/AppActionTypes';
import { isActionFactory } from '../../app/actions/isActionFactory';
import { SpaceInfo } from '../state/SpaceInfo';
import { ReorderItemAction } from './ReorderItem';

export interface CallReorderItemAction extends ReorderItemAction {}

export function callFavoritesReorder(fromIndex: number, indexToMoveAfter: number, spaceInfo: SpaceInfo): CallReorderItemAction {
  return {
    type: CallFavoritesReorderItem,
    spaceInfo,
    fromIndex,
    indexToMoveAfter: indexToMoveAfter,
  };
}

export const isCallReorderItemAction = isActionFactory<CallReorderItemAction>(CallFavoritesReorderItem);
